import "url-polyfill";
import request from "/utils/request";

export default () => request
  .get("/api/mickey_mouse/setup", { params: getParams() })
  .then(config => {
    if (config) {
      return config;
    } else {
      throw new Error("No config data found in Mickey Mouse response");
    }
  });

const getParamsFromPageUrl = () => {
  const url = new URL(window.location.href);
  const params = {
    pathname: url.pathname,
    search: url.searchParams.toString()
  };
  url.searchParams.forEach((value, key) => {
    params[key] = value;
  });
  return params;
};

const getReferrerUrl = () => {
  if (typeof document.referrer !== "undefined" && document.referrer.length > 0) {
    const urlParts = document.referrer.split("?");
    // eslint-disable-next-line camelcase
    return { referrer_url: encodeURI(urlParts[0]) };
  } else {
    return {};
  }
};

const getLocale = () => {
  let langTag = document.querySelector("meta[http-equiv='language']");
  if (langTag) {
    return { locale: langTag.getAttribute("content") };
  } else {
    return {};
  }
};

const getParams = () => {
  return {
    ...getParamsFromPageUrl(),
    ...getReferrerUrl(),
    ...getLocale()
  };
};
